import 'core-js/fn/object/assign';
import React from 'react';
import ReactDOM from 'react-dom';
import Home from './components/Home';
import Propos from './components/Propos/Propos';
import Pros from './components/Professionnel/Pros';
//import AppComponent from './components/AppComponent'
import { Router, Route, browserHistory } from 'react-router';

import { I18nextProvider } from 'react-i18next';
import i18n from './components/i18n';

// Render the main component into the dom
ReactDOM.render((
		 
		  
           <Router history={browserHistory}>
		 	<Route path="/" component={Home} />
		 	<Route path="propos" component={Propos} />
		 	<Route path="pros" component={Pros} />
		  </Router>
         
     ),document.getElementById('app'));



// WEBPACK FOOTER //
// ./src/index.js